import React from 'react'
import styled from 'styled-components'
import { CheckmarkIcon, CloseIcon, LinkExternal } from '@pancakeswap/uikit'
import { getXrplTxUrl, BithompTransaction } from '../../../xrpl'

const TransactionState = styled.div<{ pending: boolean; success?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none !important;
  border-radius: 0.5rem;
  padding: 0.25rem 0rem;
  font-weight: 500;
  font-size: 0.825rem;
  color: ${({ theme }) => theme.colors.primary};
`

const IconWrapper = styled.div<{ pending: boolean; success?: boolean }>`
  color: ${({ pending, success, theme }) =>
    pending ? theme.colors.primary : success ? theme.colors.success : theme.colors.failure};
`

const formatSummary = (tx: BithompTransaction) => {
  const delivered = tx?.outcome?.deliveredAmount
  const sourceMax = tx?.specification?.source?.maxAmount
  const amount = delivered?.value || sourceMax?.value
  const currency = delivered?.currency || sourceMax?.currency
  if (amount && currency) {
    return `${tx.type} ${amount} ${currency}`
  }
  return tx.type
}

export default function Transaction({ tx }: { tx: BithompTransaction }) {
  const summary = tx?.id ? formatSummary(tx) : 'Transaction'
  const pending = false
  const success = tx?.outcome?.result === 'tesSUCCESS'

  if (!tx?.id) return null

  return (
    <TransactionState pending={pending} success={success}>
      <LinkExternal href={getXrplTxUrl(tx.id)}>{summary ?? tx.id}</LinkExternal>
      <IconWrapper pending={pending} success={success}>
        {success ? <CheckmarkIcon color="success" /> : <CloseIcon color="failure" />}
      </IconWrapper>
    </TransactionState>
  )
}
